import { render } from "./PersonListLight.vue?vue&type=template&id=1eab232d&scoped=true"
import script from "./PersonListLight.vue?vue&type=script&lang=js"
export * from "./PersonListLight.vue?vue&type=script&lang=js"

import "./PersonListLight.vue?vue&type=style&index=0&id=1eab232d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eab232d"]])

export default __exports__